import { Button, SuperEllipse, Typography } from '@themenu/design-system'

type SuccessStepProps = {
  onFinish?: () => void
}

export const SuccessStep = ({ onFinish }: SuccessStepProps) => {
  const handleFinish = () => {
    onFinish?.()
  }

  return (
    <div className="flex flex-col items-center gap-24">
      <SuperEllipse icon="check" size={80} colorSet="success" />
      <Typography variant="body">
        Agradecemos a sua colaboração! <br />
        Acompanharemos sua empresa de perto e enviaremos instruções detalhadas
        conforme cada fase avançar.
      </Typography>
      <div className="flex self-stretch flex-col-reverse justify-center gap-8 md:flex-row">
        <Button size={40} onClick={handleFinish}>
          Concluir
        </Button>
      </div>
    </div>
  )
}
